import axios from "axios";


export default axios.create({
    baseURL: "http://localhost:5000/",
});

// https://admin-l.herokuapp.com/
// https://admin-l.herokuapp.com/
// http://localhost:5000/